import cashiLogo from "../assets/cashilogo.png";

export const CASHI_TAGLINE = "Shop Local. Earn Rewards. Build Community.";
export { cashiLogo };

const LOGO_RATIO = 464 / 1708;
let logoDataUrl;

export function cashiLogoDataUrl() {
  if (logoDataUrl) return Promise.resolve(logoDataUrl);
  return fetch(cashiLogo)
    .then((response) => response.blob())
    .then((blob) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        logoDataUrl = String(reader.result || "");
        resolve(logoDataUrl);
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(blob);
    }));
}

export async function addCashiLogo(doc, x, y, width) {
  const data = await cashiLogoDataUrl();
  const height = width * LOGO_RATIO;
  doc.addImage(data, "PNG", x, y, width, height);
  return y + height;
}
